import { store } from '../store/store.js';
import router from '../router/index.js';
import { config } from '../config.js';

const _APIURL = config.APIURL;


export const apiService = {
  login,
  trySSO,
  getNavbar,
  getTKStatus,
  setTKStatus,
  getITStatus
}

async function handleResponse(response) {
  const body = await response.text();
  const jsonBody = JSON.parse(body);

  if (!response.ok) {
    if (response.status == 401) {
      await store.dispatch('logout');
      if (router.currentRoute.fullPath !== '/login') {
        await router.push('/login');
      }
    }
    let error = new Error(jsonBody.message || '');
    error.data = jsonBody;
    throw error;
  } else {
    //OK
    return jsonBody;
  }
}
/*
function getQueryString(obj) {
  let string = '';
  for (let key in obj) {
    if (obj[key]) {
      string += string ? `&${key}=${obj[key]}` : `?${key}=${obj[key]}`;
    }
  }

  return string;
}
*/

async function login(username, password) {
  //let data = { username, password, strategy: 'ldap' };
  let data = { username, password };

  const request = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  }

  const response = await fetch(`${_APIURL}/frontend/v1/login`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function trySSO() {

  const request = {
    method: 'GET'
  }

  const response = await fetch(`${_APIURL}/sso`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function getNavbar() {

  const request = {
    method: 'GET',
    /*headers: {
      //'Authorization': 'Bearer ' + store.state.token,
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.token}`
    }*/
  }
  const response = await fetch(`${_APIURL}/frontend/v1/navigation`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function getTKStatus() {

  const request = {
    method: 'GET',
    headers: {
      //'Authorization': 'Bearer ' + store.state.token,
      //'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.token}`
    }
  }
  const response = await fetch(`${_APIURL}/frontend/v1/tk/status`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function getITStatus() {

  const request = {
    method: 'GET',
    headers: {
      //'Authorization': 'Bearer ' + store.state.token,
      //'Content-Type': 'application/json',
      //'Authorization': `Bearer ${store.state.token}`
    }
  }
  const response = await fetch(`${_APIURL}/it/v1/status`, request);
  const parsed = await handleResponse(response);
  return parsed;
}

async function setTKStatus(status) {

  const request = {
    method: 'POST',
    headers: {
      //'Authorization': 'Bearer ' + store.state.token,
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${store.state.token}`
    },
    body: JSON.stringify({status})
  }
  const response = await fetch(`${_APIURL}/frontend/v1/tk/status`, request);
  const parsed = await handleResponse(response);
  return parsed;
}